import { Location } from "history";

import { PartialLocation } from "common/types/routing";

import { MODAL_ROUTES } from "routing/routes";

export default function linkToQuitSessionWithDestination({
  link,
  currentLocation
}: {
  link: string | PartialLocation;
  currentLocation: Location<any>;
}) {
  let destination: Location;

  if (typeof link === "string") {
    const [baseLink, searchParams] = link.split("?");
    const params = new URLSearchParams(searchParams).toString();

    destination = {
      pathname: baseLink,
      state: undefined,
      search: params,
      hash: ""
    };
  } else {
    destination = {
      pathname: link.pathname,
      state: link.state,
      search: link.search || "",
      hash: ""
    };
  }

  return {
    pathname: MODAL_ROUTES.QUIT_SESSION.buildPath({}),
    state: MODAL_ROUTES.QUIT_SESSION.buildState({
      destination,
      background: currentLocation
    }),
    search: "",
    hash: ""
  };
}
